<template>
     <div>
        <div class="meny_wrap">
              <cateboxApp></cateboxApp>
        </div>
        <div class="boxs_wrap">
            <div class="container-fluid container-xl">
            <menyboxApp></menyboxApp>
            </div>
        </div>
  </div>
</template>

<script>
import cateboxApp from '@/components/meny/cateboxApp.vue';
import menyboxApp from '@/components/meny/menyboxApp.vue';
export default {
   name:'Meny',
   components:{
        cateboxApp,
        menyboxApp
    }
   
}
</script>

<style lang="scss" scoped>
.boxs_wrap{
    margin-top: 120px;
}
.meny_wrap{
    padding-top: 80px;
}
</style>